import { InfoCircleTwoTone } from "@ant-design/icons";
import { MonitorBase } from "@p0security/shared/types/assessment/monitor";
import { Flex, Tooltip } from "@p0security/ui";

import { MonitorPriority } from "./MonitorSeverity";

const priorityOverlay = (
  <Flex vertical gap="small">
    <div>
      <MonitorPriority monitor={{ priority: "CRITICAL" }} />
      &nbsp;Active security vulnerability; fix immediately
    </div>
    <div>
      <MonitorPriority monitor={{ priority: "HIGH" }} />
      &nbsp;Violation of best practices; may enable a security vulnerability
    </div>
    <div>
      <MonitorPriority monitor={{ priority: "MEDIUM" }} />
      &nbsp;Informational; use to further understand your security posture
    </div>
    <div>
      <MonitorPriority monitor={{ priority: "LOW" }} />
      &nbsp;No security risk; use to inventory your system
    </div>
  </Flex>
);

export const PriorityTooltip: React.FC<{
  monitor?: Pick<MonitorBase, "priority">;
}> = ({ monitor }) => (
  <Tooltip title={priorityOverlay} overlayStyle={{ maxWidth: 500 }}>
    {monitor ? (
      <span style={{ cursor: "help" }}>
        <MonitorPriority monitor={monitor} />
      </span>
    ) : (
      <InfoCircleTwoTone />
    )}
  </Tooltip>
);
